import instance from '@/api/business'
import {
    UnsettledSecuritiesPosition1,
    UnsettledSecuritiesPosition2,
    UnsettledSecuritiesPosition3,
    UnsettledSecuritiesTotalPosition,
    PositionSummary,
    ProductTotalPosition,
    UnsettledSecuritiesPositionTotalProps,
    UnsettledSecuritiesPositionTotal,
    UnsettledSecuritiesPendingTitles
} from './type'

const BASE_URL = '/unsettledsecurities/crweb'

export const fetchUnsettledSecuritiesPosition1 = async () => {
    const response = await instance.post<UnsettledSecuritiesPosition1[]>(`${BASE_URL}/position1`)

    return response.data
}

export const fetchUnsettledSecuritiesPosition2 = async () => {
    const response = await instance.post<UnsettledSecuritiesPosition2[]>(`${BASE_URL}/position2`)

    return response.data
}

export const fetchUnsettledSecuritiesPosition3 = async () => {
    const response = await instance.post<UnsettledSecuritiesPosition3[]>(`${BASE_URL}/position3`)

    return response.data
}

export const fetchTotalPosition = async () => {
    const response = await instance.post<UnsettledSecuritiesTotalPosition[]>(`${BASE_URL}/totalposition`)

    return response.data
}

export const fetchPositionDashBoard = async () => {
    const response = await instance.post<UnsettledSecuritiesTotalPosition[]>(`${BASE_URL}/positiondashboard`)

    return response.data
}


export const fetchProductTotalPosition = async () => {
    const response = await instance.post<ProductTotalPosition[]>(`${BASE_URL}/producttotalposition`)

    return response.data
}

export const fetchPositionSumarry = async () => {
    const response = await instance.post<PositionSummary[]>(`${BASE_URL}/positionsumarry`)

    return response.data

}
export const fetchUnsettledSecuritiesPositionTotal = async (data: UnsettledSecuritiesPositionTotalProps) => {
    const response = await instance.post<UnsettledSecuritiesPositionTotal[]>(`${BASE_URL}/selectunsettledsecuritiespositiontotal`, data)

    return response.data
}

export const marcarComoPendentePosition1 = async (ids: string[]) => {
    const response = await instance.post(`${BASE_URL}/position1/marcar-pendente`, { ids })
    return response.data
}

export const removerDePendentePosition1 = async (ids: string[]) => {
    const response = await instance.post(`${BASE_URL}/position1/remover-pendente`, { ids })
    return response.data
}

export const marcarComoPendentePosition2 = async (ids: string[]) => {
    const response = await instance.post(`${BASE_URL}/position2/marcar-pendente`, { ids })
    return response.data
}

export const removerDePendentePosition2 = async (ids: string[]) => {
    const response = await instance.post(`${BASE_URL}/position2/remover-pendente`, { ids })
    return response.data
}

export const marcarComoPendentePosition3 = async (ids: string[]) => {
    const response = await instance.post(`${BASE_URL}/position3/marcar-pendente`, { ids })
    return response.data
}

export const removerDePendentePosition3 = async (ids: string[]) => {
    const response = await instance.post(`${BASE_URL}/position3/remover-pendente`, { ids })
    return response.data
}

export const fetchPendingTitles = async () => {
    const response = await instance.post<UnsettledSecuritiesPendingTitles[]>(`${BASE_URL}/pendingtitles`)
    return response.data
} 